import type { ReactNode } from "react";

export function Content({ children }: { children: ReactNode }) {
  return (
    <div className="nbs-content">
      <div className="nbs-content__inner">{children}</div>
    </div>
  );
}
